<template>
  <div>
    <v-data-table
        :no-data-text="$t('noData')"
        :no-results-text="$t('noResults')"
      item-key="name"
      :loading="loading"
      :loading-text="$t('loading_text')"
      :headers="mode == 1 || mode == 3 ? translatedHeaders : translatedSuspendedHeaders"
      :items="trips"
      :search="search"
      :footer-props="footerProps"
    >
      <template v-slot:top>
        <v-text-field
          v-model="search"
          :label="$t('search')"
          class="mx-4"
        ></v-text-field>
      </template>

      <template
        v-if="mode == 1 || mode == 3"
        v-slot:item.first_stop_time="{ item }"
      >
        <small>{{ tConvert(item.first_stop_time) }}</small>
      </template>

      <template v-if="mode == 2" v-slot:item.trip.first_stop_time="{ item }">
        <small>{{ tConvert(item.trip.first_stop_time) }}</small>
      </template>

      <template v-slot:item.repetition_period="{ item }">
        <span v-if="item.repetition_period == 0">{{$t('only_once')}}</span>
        <span v-else-if="item.repetition_period == 1">{{$t('daily')}}</span>
        <span v-else>{{$t('every_days', { count: item.repetition_period })}}</span>
      </template>

      <template
        v-if="mode == 1 || mode == 3"
        v-slot:item.last_stop_time="{ item }"
      >
        <small>{{ tConvert(item.last_stop_time) }}</small>
      </template>

      <template v-if="mode == 2" v-slot:item.trip.last_stop_time="{ item }">
        <small>{{ tConvert(item.trip.last_stop_time) }}</small>
      </template>

      <template v-if="mode == 1 || mode == 3" v-slot:item.route.name="{ item }">
        <a v-if="item.route.name" @click.stop="displayRoute(item.route.id)">{{
          item.route.name
        }}</a>
        <span v-else>{{$t('no_route')}}</span>
      </template>

      <template v-if="mode == 2" v-slot:item.trip.route.name="{ item }">
        <a
          v-if="item.trip.route.name"
          @click.stop="displayRoute(item.trip.route.id)"
          >{{ item.trip.route.name }}</a
        >
        <span v-else>{{$t('no_route')}}</span>
      </template>

      <template v-slot:item.driver="{ item }">
        <div class="d-flex align-center">
          <v-chip :color="getDriverAssignmentColor(item.driver)" dark @click="assignDriver(item)">
            {{ getTripDriver(item.driver) }}
          </v-chip>
          <v-chip v-if="item.is_tracking_stale" x-small color="error" dark class="ms-1 font-weight-bold" style="white-space: nowrap;" title="لم يصل تحديث للموقع منذ أكثر من 5 دقائق">
            🔺 مشكلة اتصال
          </v-chip>
        </div>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-menu offset-y
          right
          nudge-bottom="4">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                small
                v-bind="attrs"
                v-on="on"
              >
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(itm, index) in actionMenuItems()"
              :key="index"
              :value="index"
            >
            <div
            @click="doMenuAction(item, index)" class="d-flex align-center justify-start w-100">
              <v-list-item-icon>
                <v-icon>{{ itm.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="mx-2">{{ itm.title }}</v-list-item-title>
            </div>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:item.delay_report="{ item }">
        <v-btn color="purple darken-2" dark small class="font-weight-bold elevation-1 text-none" @click="openTripReport(item)">
          <v-icon left small>mdi-file-chart-outline</v-icon>
          تقارير الرحلة
        </v-btn>
      </template>
      <!-- <template v-slot:item.actions1="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-if="mode == 1" v-bind="attrs" v-on="on" small class="mr-2" @click="assignDriver(item)">
              mdi-account-tie-hat
            </v-icon>
          </template>
          <span>Assign driver</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" small class="mr-2" @click="viewTrip(item)">
              mdi-eye
            </v-icon>
          </template>
          <span>View</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" small class="mr-2" @click="viewTripCalendar(item)">
              mdi-calendar
            </v-icon>
          </template>
          <span>Calendar</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-if="mode == 1"
              v-bind="attrs" v-on="on"
              small
              class="mr-2"
              @click="duplicateTrip(item)"
            >
              mdi-content-duplicate
            </v-icon>
          </template>
          <span>Duplicate</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs" v-on="on"
              small
              v-if="mode == 1 || mode == 3"
              @click="trashRestoreTrip(item, trips.indexOf(item))"
            >
              {{ item.status_id != 1 ? icons.mdiBackupRestore : icons.mdiTrashCan }}
            </v-icon>

            <v-icon
              v-bind="attrs" v-on="on"
              small
              v-if="mode == 2"
              @click="deleteSuspension(item, trips.indexOf(item))"
            >
              {{ icons.mdiBackupRestore }}
            </v-icon>
          </template>
          <span>{{item.status_id != 1 ? 'Restore' : 'Trash'}}</span>
        </v-tooltip>
      </template> -->
    </v-data-table>
    <v-dialog v-if="selectedTrip" v-model="dialog" max-width="1150" width="95%" scrollable>
      <v-card class="rounded-lg">
        <v-card-title class="headline primary white--text py-3 px-4 d-flex justify-space-between align-center">
          <div class="subtitle-1 font-weight-bold">
            <v-icon color="white" class="me-2">mdi-account-tie-hat</v-icon>
            تسكين السائقين للرحلة (معرف #{{ selectedTrip.id }} - {{ selectedTrip.route ? selectedTrip.route.name : '' }})
          </div>
          <v-btn icon dark small @click="closeDriverModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-4 px-4">
          <!-- Parent trip paused warning alert -->
          <v-alert v-if="scheduleData && scheduleData.is_parent_paused" type="warning" dense class="mb-3 font-weight-bold">
            هذه الرحلة متوقفة مؤقتًا بالكامل. أعد تفعيل الرحلة من القائمة الرئيسية لإدارة التسكين.
          </v-alert>

          <!-- Feature 2: 7-Occurrence Driver Assignment Board -->
          <div class="mb-4">
            <div class="d-flex align-center justify-space-between mb-2">
              <div class="font-weight-bold subtitle-2 d-flex align-center" style="color: #111111 !important; opacity: 1 !important;">
                <v-icon small color="primary" class="me-1">mdi-calendar-week</v-icon>
                جدول التسكين للأيام القادمة (أقرب 7 مواعيد تشغيل)
              </div>
              <v-progress-circular v-if="loadingSchedule" indeterminate size="18" width="2" color="primary"></v-progress-circular>
            </div>

            <!-- Schedule Summary Strip -->
            <div v-if="scheduleSummary" class="d-flex align-center justify-start flex-wrap mb-3 gap-2">
              <v-chip x-small color="success lighten-4" class="font-weight-bold me-2 mb-1" style="color: #0d532b !important; opacity: 1 !important;">
                <v-icon x-small left color="green darken-4">mdi-check-circle</v-icon>
                {{ scheduleSummary.assigned_count }} أيام مسكنة
              </v-chip>
              <v-chip x-small color="purple lighten-5" class="font-weight-bold me-2 mb-1" style="color: #4a148c !important; opacity: 1 !important;">
                <v-icon x-small left color="purple darken-4">mdi-account-off-outline</v-icon>
                {{ scheduleSummary.unassigned_count }} بدون سائق
              </v-chip>
              <v-chip x-small color="warning lighten-4" class="font-weight-bold me-2 mb-1" style="color: #b78103 !important; opacity: 1 !important;">
                <v-icon x-small left color="orange darken-4">mdi-alert-circle</v-icon>
                {{ scheduleSummary.conflict_count }} تعارض
              </v-chip>
              <v-chip x-small color="grey lighten-2" class="font-weight-bold me-2 mb-1" style="color: #212121 !important; opacity: 1 !important;">
                <v-icon x-small left color="grey darken-4">mdi-pause-circle</v-icon>
                {{ scheduleSummary.paused_count }} متوقفة مؤقتًا
              </v-chip>
            </div>

            <!-- 7 Horizontal Cards Strip -->
            <div v-if="scheduleOccurrences.length > 0" class="schedule-occurrences-strip d-flex pb-2 mb-3" style="overflow-x: auto; gap: 10px;">
              <div
                v-for="occ in scheduleOccurrences"
                :key="occ.planned_trip_id"
                class="occurrence-card pa-2 rounded-lg border cursor-pointer flex-shrink-0 d-flex flex-column justify-space-between"
                :class="[
                  selectedOccurrence && selectedOccurrence.planned_trip_id === occ.planned_trip_id ? 'occurrence-card-selected' : '',
                  occ.is_paused ? 'occurrence-card-paused' : (occ.has_conflict ? 'occurrence-card-conflict' : (occ.driver_id ? 'occurrence-card-assigned' : 'occurrence-card-unassigned'))
                ]"
                style="min-width: 135px; width: 135px; user-select: none;"
                @click="selectOccurrence(occ)"
              >
                <div>
                  <div class="font-weight-bold text-caption text-truncate" style="color: #111111 !important; opacity: 1 !important;">{{ occ.day_name }}</div>
                  <div class="text-caption mb-2" style="font-size: 0.75rem; color: #374151 !important; font-weight: 600; opacity: 1 !important;">{{ occ.formatted_date }}</div>

                  <v-chip
                    x-small
                    label
                    class="font-weight-bold w-100 justify-center mb-2"
                    :color="getOccurrenceBadgeColor(occ)"
                    :dark="occ.is_paused || occ.assignment_status === 'assigned'"
                    style="opacity: 1 !important;"
                  >
                    {{ getOccurrenceBadgeText(occ) }}
                  </v-chip>
                </div>

                <div>
                  <div v-if="occ.driver" class="caption font-weight-bold text-truncate text-center" style="color: #111111 !important; opacity: 1 !important;">
                    <v-icon x-small color="primary" class="me-1">mdi-account</v-icon>
                    {{ occ.driver.name }}
                  </div>
                  <div v-else-if="!occ.is_paused" class="caption text-center font-weight-bold" style="color: #374151 !important; opacity: 1 !important;">
                    بدون سائق
                  </div>
                  <div v-else class="caption text-center font-weight-bold" style="color: #4b5563 !important; opacity: 1 !important;">
                    متوقفة
                  </div>
                </div>
              </div>
            </div>

            <!-- Selected Day Info & Action Header -->
            <div v-if="selectedOccurrence" class="selected-occ-bar pa-3 mb-3 rounded-lg grey lighten-4 d-flex align-center justify-space-between flex-wrap" style="opacity: 1 !important;">
              <div class="d-flex align-center my-1">
                <v-icon color="primary" class="me-2">mdi-calendar-check</v-icon>
                <div>
                  <div class="font-weight-bold text-subtitle-2" style="color: #111111 !important; opacity: 1 !important;">
                    اليوم المحدد: {{ selectedOccurrence.day_name }} {{ selectedOccurrence.formatted_date }}
                  </div>
                  <div class="caption font-weight-bold" style="color: #1f2937 !important; opacity: 1 !important;">
                    <span v-if="selectedOccurrence.driver" class="primary--text font-weight-bold">
                      السائق الحالي: {{ selectedOccurrence.driver.name }}
                    </span>
                    <span v-else style="color: #374151 !important;">لم يتم تسكين سائق لهذا اليوم بعد</span>
                    <span v-if="selectedOccurrence.is_paused" class="ms-2 error--text font-weight-bold">
                      (الرحلة متوقفة مؤقتًا)
                    </span>
                  </div>
                </div>
              </div>

              <div class="d-flex align-center my-1">
                <!-- Toggle Pause for selected occurrence -->
                <v-btn
                  v-if="!selectedOccurrence.movement_started_at && !selectedOccurrence.ended_at && !selectedOccurrence.cancelled_at && !selectedOccurrence.is_paused"
                  x-small
                  color="warning"
                  outlined
                  class="font-weight-bold me-2"
                  @click="toggleOccurrencePause(selectedOccurrence)"
                >
                  <v-icon x-small left>mdi-pause-circle-outline</v-icon>
                  إيقاف مؤقت لهذا اليوم
                </v-btn>

                <v-btn
                  v-else-if="!selectedOccurrence.movement_started_at && !selectedOccurrence.ended_at && !selectedOccurrence.cancelled_at && selectedOccurrence.is_paused"
                  x-small
                  color="success"
                  outlined
                  class="font-weight-bold me-2"
                  @click="toggleOccurrencePause(selectedOccurrence)"
                >
                  <v-icon x-small left>mdi-play-circle-outline</v-icon>
                  إعادة التفعيل
                </v-btn>

                <!-- Remove driver assignment for selected occurrence -->
                <v-btn
                  v-if="selectedOccurrence.driver_id && !selectedOccurrence.is_paused && !selectedOccurrence.movement_started_at"
                  x-small
                  color="error"
                  text
                  class="font-weight-bold"
                  @click="removeDriverFromOccurrence(selectedOccurrence)"
                >
                  <v-icon x-small left>mdi-account-remove</v-icon>
                  إزالة السائق
                </v-btn>
              </div>
            </div>
          </div>

          <v-divider class="mb-4"></v-divider>

          <!-- Driver search inside modal -->
          <div v-if="selectedOccurrence" class="font-weight-bold caption grey--text text--darken-2 mb-2">
            السائقون المتاحون ليوم {{ selectedOccurrence.day_name }} {{ selectedOccurrence.formatted_date }}
          </div>
          <v-text-field
            v-model="driverSearch"
            :label="$t('search_by_driver_name_or_phone')"
            prepend-inner-icon="mdi-magnify"
            clearable
            outlined
            dense
            hide-details
            class="mb-4"
            @input="onDriverSearchInput"
            @click:clear="onDriverSearchClear"
          ></v-text-field>

          <v-progress-linear
            v-if="loadingDrivers"
            indeterminate
            color="primary"
            class="mb-3"
          ></v-progress-linear>

          <div v-if="!loadingDrivers && availableDrivers.length === 0" class="text-center py-6 text--secondary">
            <v-icon size="48" color="grey lighten-1">mdi-account-search-outline</v-icon>
            <div class="mt-2">{{ $t('noData') }}</div>
          </div>

          <div v-else class="driver-cards-wrapper" style="max-height: 340px; overflow-y: auto;">
            <div
              v-for="driver in availableDrivers"
              :key="driver.id"
              class="driver-card pa-3 mb-3 rounded-lg border d-flex flex-column"
              :class="isDriverCurrentlyAssigned(driver) ? 'driver-card-assigned-active' : (isDriverConflict(driver) ? 'driver-card-conflict' : (isDriverRestricted(driver) ? 'driver-card-restricted' : 'driver-card-available'))"
            >
              <div class="d-flex align-center justify-space-between flex-wrap">
                <div class="d-flex align-center my-1">
                  <v-avatar size="44" class="me-3 grey lighten-3">
                    <img v-if="driver.avatar_url" :src="driver.avatar_url" :alt="driver.name" />
                    <v-icon v-else color="primary">mdi-account</v-icon>
                  </v-avatar>
                  <div>
                    <div class="font-weight-bold text-subtitle-2">
                      {{ driver.name }}
                      <v-chip v-if="isDriverCurrentlyAssigned(driver)" x-small color="primary" class="ms-1 font-weight-bold">
                        مسكن حاليًا
                      </v-chip>
                    </div>
                    <div class="caption text--secondary d-flex align-center flex-wrap">
                      <span class="me-2"><v-icon x-small class="me-1">mdi-phone</v-icon>{{ driver.phone_number || driver.tel_number || '-' }}</span>
                      <v-chip v-if="driver.bus" x-small color="grey lighten-3" class="grey--text text--darken-3 font-weight-bold">
                        <v-icon x-small left color="grey darken-3">mdi-bus</v-icon>{{ driver.bus.license_number || driver.bus.bus_number || driver.bus.license || 'Bus' }}
                      </v-chip>
                    </div>
                  </div>
                </div>

                <div class="d-flex align-center my-1">
                  <v-chip
                    small
                    class="me-2 font-weight-bold"
                    :color="isDriverCurrentlyAssigned(driver) ? 'primary lighten-4 primary--text text--darken-3' : (isDriverRestricted(driver) ? 'error lighten-4 red--text text--darken-3' : (isDriverConflict(driver) ? 'warning lighten-4 orange--text text--darken-3' : 'success lighten-4 green--text text--darken-4'))"
                    style="opacity: 1 !important;"
                  >
                    <v-icon x-small left :color="isDriverCurrentlyAssigned(driver) ? 'primary darken-3' : (isDriverRestricted(driver) ? 'red darken-3' : (isDriverConflict(driver) ? 'orange darken-3' : 'green darken-4'))">
                      {{ isDriverCurrentlyAssigned(driver) ? 'mdi-check-all' : (isDriverRestricted(driver) ? 'mdi-cancel' : (isDriverConflict(driver) ? 'mdi-alert-circle' : 'mdi-check-circle')) }}
                    </v-icon>
                    {{ isDriverCurrentlyAssigned(driver) ? 'المسكن حاليًا' : (isDriverRestricted(driver) ? 'مستند مرفوض' : (isDriverConflict(driver) ? 'تعارض في الجدول' : 'متاح للتعيين')) }}
                  </v-chip>

                  <v-btn
                    small
                    :color="isDriverCurrentlyAssigned(driver) ? 'primary' : (isDriverRestricted(driver) ? 'grey' : (isDriverConflict(driver) ? 'warning darken-1' : 'success darken-1'))"
                    dark
                    depressed
                    :disabled="(selectedOccurrence && selectedOccurrence.is_paused) || (scheduleData && scheduleData.is_parent_paused)"
                    @click="assignDriverToTrip(driver)"
                  >
                    <v-icon x-small left>{{ isDriverCurrentlyAssigned(driver) ? 'mdi-check-bold' : 'mdi-check' }}</v-icon>
                    {{ isDriverCurrentlyAssigned(driver) ? 'تم التعيين' : $t('select') }}
                  </v-btn>
                </div>
              </div>

              <!-- Conflict / Restriction details notice -->
              <div v-if="!isDriverCurrentlyAssigned(driver) && getDriverNoticeMessage(driver)" class="conflict-alert pa-2 mt-2 rounded red lighten-5 error--text caption d-flex align-center justify-space-between">
                <div class="d-flex align-center text-truncate me-1">
                  <v-icon x-small color="error" class="me-1">mdi-alert-outline</v-icon>
                  <span class="text-truncate">{{ getDriverNoticeMessage(driver) }}</span>
                </div>
                <v-tooltip bottom max-width="360">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon x-small v-bind="attrs" v-on="on" class="ms-1">
                      <v-icon small color="error">mdi-information-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ getDriverNoticeMessage(driver) }}</span>
                </v-tooltip>
              </div>
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="px-4 py-2">
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-1" @click="closeDriverModal">
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog with trip time line -->
    <v-dialog v-if="selectedTripForTimeLine"
    v-model="timeLineDialog" max-width="400">
      <v-card>
        <v-card-title>
          <v-icon color="primary">
            mdi-clock-time-four-outline
          </v-icon>
          <span class="px-2">{{$t('trip_timeline')}}</span>
        </v-card-title>
        <v-card-text v-if="notEnoughHistoryForTimeLine(selectedTripForTimeLine)">
          <div class="text-h6 pa-4"> {{$t('no_enough_history', { tripId: selectedTripForTimeLine.id, routeName: selectedTripForTimeLine.route.name })}} </div>
        </v-card-text>
        <v-card-text>
          <v-timeline align-top>
            <v-timeline-item
              v-for="(detail, index) in selectedTripForTimeLine.stopTimes"
              :key="detail.id"
            >
              <div class="pt-1">
                  <div><strong>{{ detail.stop_name }}</strong></div>
                  <div class="text-caption">
                    {{ detail.planned_time }}
                  </div>
                  <div v-if="detail.count_pre != 0" class="error--text">
                    {{$t('early')}} {{ detail.avg_diff_pre }} {{$t('min')}}
                  </div>
                  <div v-if="detail.count_post != 0" class="error--text">
                    {{$t('late')}} {{ detail.avg_diff_post }} {{$t('min')}}
                  </div>
              </div>
            </v-timeline-item>
          </v-timeline>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="timeLineDialog = false">
            {{$t('close')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <trip-report-modal v-model="reportDialog" :trip="selectedTripForReport"></trip-report-modal>
  </div>
</template>

<script>
import TripReportModal from './TripReportModal.vue';
import {
  mdiStopCircleOutline,
  mdiPlayCircleOutline,
  mdiTrashCan,
  mdiDeleteRestore,
  mdiAirplane,
  mdiBackupRestore,
} from "@mdi/js";
import moment from 'moment';

export default {
  components: {
    TripReportModal,
  },
  props: {
    trips: Array,
    mode: Number,
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      minMinutesForDelay: 5,
      isLoading: false,
      search: "",
      driverSearch: "",
      driverSearchTimeout: null,
      loadingDrivers: false,
      availableDrivers: [],
      dialog: false,
      reportDialog: false,
      selectedTripForReport: null,
      selectedTrip: null,
      selectedTripForTimeLine: null,
      timeLineDialog: false,
      loadingSchedule: false,
      scheduleData: null,
      scheduleOccurrences: [],
      scheduleSummary: null,
      selectedOccurrence: null,
      actionItemsActive: [
        {title: "edit", icon: 'mdi-pencil' },
        {title: "view", icon: 'mdi-eye' },
        {title: "assign_driver", icon: 'mdi-account-tie-hat'},
        {title: "calendar", icon: 'mdi-calendar' },
        {title: "duplicate", icon: 'mdi-content-duplicate' },
        {title: "إيقاف الرحلة", icon: 'mdi-motion-pause' },
        {title: "trash", icon: 'mdi-trash-can' },
      ],
      actionItemsPaused: [
        {title: "view", icon: 'mdi-eye' },
        {title: "assign_driver", icon: 'mdi-account-tie-hat'},
        {title: "calendar", icon: 'mdi-calendar' },
        {title: "إعادة التفعيل", icon: 'mdi-play-circle-outline' },
        {title: "trash", icon: 'mdi-trash-can' },
      ],
      actionItemsSuspended: [
        {title: "View", icon: 'mdi-eye' },
        {title: "calendar", icon: 'mdi-calendar' },
        {title: "restore", icon: 'mdi-backup-restore' },
      ],
      actionItemsTrashed: [
        {title: "view", icon: 'mdi-eye' },
        {title: "calendar", icon: 'mdi-calendar' },
        {title: "restore", icon: 'mdi-backup-restore' },
      ],
      headers: [
        { text: "id", value: "id", align: "start"},
        { text: "route", value: "route.name" },
        { text: "first_stop", value: "first_stop_time" },
        { text: "last_stop", value: "last_stop_time" },
        { text: "repeated", value: "repetition_period" },
        { text: "effective", value: "effective_date" },
        { text: "Driver", value: "driver" },
        { text: "delay_report", value: "delay_report" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      suspendedHeaders: [
        { text: "id", value: "trip.id", align: "start"},
        { text: "route", value: "trip.route.name" },
        { text: "first_stop", value: "trip.first_stop_time" },
        { text: "last_stop", value: "trip.last_stop_time" },
        { text: "suspension_date", value: "date" },
        { text: "suspension_repetition", value: "repetition_period" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      icons: {
        mdiStopCircleOutline,
        mdiPlayCircleOutline,
        mdiTrashCan,
        mdiDeleteRestore,
        mdiAirplane,
        mdiBackupRestore,
      },
    };
  },
  computed: {
    translatedHeaders() {
      return this.headers.map(header => ({
        ...header,
        text: header.text === 'delay_report' ? 'تقارير الرحلة' : this.$t(header.text)
      }));
    },
    translatedSuspendedHeaders() {
      return this.suspendedHeaders.map(header => ({
        ...header,
        text: this.$t(header.text)
      }));
    },
    footerProps() {
      return {
        itemsPerPageText: this.$t("rows_per_page"),
      }
    },
    translatedActionItemsActive() {
      return this.actionItemsActive.map(action => ({
        ...action,
        title: (action.title === "إيقاف الرحلة") ? "إيقاف الرحلة" : this.$t(action.title)
      }));
    },
    translatedActionItemsPaused() {
      return this.actionItemsPaused.map(action => ({
        ...action,
        title: (action.title === "إعادة التفعيل") ? "إعادة التفعيل" : this.$t(action.title)
      }));
    },
    translatedActionItemsSuspended() {
      return this.actionItemsSuspended.map(action => ({
        ...action,
        title: this.$t(action.title)
      }));
    },
    translatedActionItemsTrashed() {
      return this.actionItemsTrashed.map(action => ({
        ...action,
        title: this.$t(action.title)
      }));
    },
  },
  methods: {
    notEnoughHistoryForTimeLine(trip)
    {
      if(trip && trip.stopTimes)
      {
        var keys = Object.keys(trip.stopTimes);
        for (var i = 0; i < keys.length; i++) {
          var key = keys[i];
          if(trip.stopTimes[key].count == 0)
          {
            return true;
          }
        }
        return !this.isTripTimeNeedsAttention(trip);
      }
      return true;
    },
    getConflictMessage(driver)
    {
      if(driver && driver.trip_intersect)
      {
        var conflictTrip = driver.trip_intersect;
        var firstStopTime = conflictTrip.first_stop_time;
        var routeName = conflictTrip.route.name;
        return this.$t("conflict_with_trip", {
          tripId: conflictTrip.id,
          routeName: routeName,
          date: moment(driver.trip_intersect_date).format("LL"),
        });
      }
      return "";
    },
    isTripTimeNeedsAttention(trip)
    {
      if(trip && trip.stopTimes)
      {
        var keys = Object.keys(trip.stopTimes);
        for (var i = 0; i < keys.length; i++) {
          var key = keys[i];
          if(trip.stopTimes[key].count_pre != 0 && (trip.stopTimes[key].avg_diff_pre > this.minMinutesForDelay || trip.stopTimes[key].avg_diff_pre < -this.minMinutesForDelay))
          {
            return true;
          }
          if(trip.stopTimes[key].count_post != 0 && (trip.stopTimes[key].avg_diff_post > this.minMinutesForDelay || trip.stopTimes[key].avg_diff_post < -this.minMinutesForDelay))
          {
            return true;
          }
        }
        return false;
      }
      return false;
    },
    viewDelayReport(item)
    {
      this.selectedTripForTimeLine = item;
      this.timeLineDialog = true;
    },
    openTripReport(item)
    {
      const targetTrip = (item && item.trip) ? item.trip : item;
      this.selectedTripForReport = targetTrip;
      this.reportDialog = true;
    },
    actionMenuItems()
    {
      if(this.mode == 1)
      {
        return this.translatedActionItemsActive;
      }
      else if(this.mode == 4)
      {
        return this.translatedActionItemsPaused;
      }
      else if(this.mode == 2)
      {
        return this.translatedActionItemsSuspended;
      }
      else if(this.mode == 3)
      {
        return this.translatedActionItemsTrashed;
      }
    },
    doMenuAction(item, index) {
      if(this.mode == 1)
      {
        if(index == 0)
        {
          this.editTrip(item);
        }
        else if(index == 1)
        {
          this.viewTrip(item);
        }
        else if(index == 2)
        {
          this.assignDriver(item);
        }
        else if(index == 3)
        {
          this.viewTripCalendar(item);
        }
        else if(index == 4)
        {
          this.duplicateTrip(item);
        }
        else if(index == 5)
        {
          this.pauseParentTripAction(item);
        }
        else if(index == 6)
        {
          this.trashRestoreTrip(item, this.trips.indexOf(item));
        }
      }
      else if(this.mode == 4)
      {
        if(index == 0)
        {
          this.viewTrip(item);
        }
        else if(index == 1)
        {
          this.assignDriver(item);
        }
        else if(index == 2)
        {
          this.viewTripCalendar(item);
        }
        else if(index == 3)
        {
          this.reactivateParentTripAction(item);
        }
        else if(index == 4)
        {
          this.trashRestoreTrip(item, this.trips.indexOf(item));
        }
      }
      else if(this.mode == 2 || this.mode == 3)
      {
        if(index == 0)
        {
          this.viewTrip(item);
        }
        else if(index == 1)
        {
          this.viewTripCalendar(item);
        }
        else if(index == 2)
        {
          if(this.mode == 2)
          {
            this.deleteSuspension(item, this.trips.indexOf(item));
          }
          else if(this.mode == 3)
          {
            this.trashRestoreTrip(item, this.trips.indexOf(item));
          }
        }
      }
    },
    pauseParentTripAction(trip) {
      this.$swal.fire({
        title: "إيقاف الرحلة مؤقتًا",
        text: "هل تريد إيقاف هذه الرحلة مؤقتًا؟\nلن تظهر الرحلة ضمن الرحلات النشطة حتى يتم إعادة تفعيلها.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "نعم، إيقاف الرحلة",
        cancelButtonText: "إلغاء",
      }).then((res) => {
        if (res.isConfirmed) {
          axios.post(`/trips/${trip.id}/pause-parent`)
            .then((r) => {
              this.$notify({ title: "تم التحديث", text: r.data.message || "تم إيقاف الرحلة مؤقتًا بنجاح.", type: "success" });
              this.$emit('refreshTrips');
            })
            .catch((err) => {
              const msg = err.response ? err.response.data.message : "حدث خطأ أثناء إيقاف الرحلة";
              this.$swal("خطأ", msg, "error");
            });
        }
      });
    },
    reactivateParentTripAction(trip) {
      this.$swal.fire({
        title: "إعادة تفعيل الرحلة",
        text: "هل تريد إعادة تفعيل هذه الرحلة وعودتها للتشغيل النشط؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "نعم، إعادة التفعيل",
        cancelButtonText: "إلغاء",
      }).then((res) => {
        if (res.isConfirmed) {
          axios.post(`/trips/${trip.id}/reactivate-parent`)
            .then((r) => {
              this.$notify({ title: "تم التحديث", text: r.data.message || "تم إعادة تفعيل الرحلة بنجاح.", type: "success" });
              this.$emit('refreshTrips');
            })
            .catch((err) => {
              const msg = err.response ? err.response.data.message : "حدث خطأ أثناء إعادة تفعيل الرحلة";
              this.$swal("خطأ", msg, "error");
            });
        }
      });
    },
    getDriverAssignmentColor(driver) {
      if (driver) return "success";
      else return "error";
    },
    getTripDriver(driver) {
      if (driver) return driver.name;
      else return this.$t("none");
    },
    tConvert(time) {
      if (time == null) {
        return null;
      }
      // Check correct time format and split into components
      time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)/) || [time];

      if (time.length > 1) {
        // If time format correct
        time = time.slice(1); // Remove full string match value
        time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
      }
      return time.join(""); // return adjusted time or original string
    },
    displayRoute(route_id) {
      this.$router.push({
        name: "view-route",
        params: { route_id: route_id },
      });
    },

    trashRestoreTrip(trip, index) {
      this.$emit("trashRestoreTrip", trip, index);
    },

    deleteSuspension(trip, index) {
      this.$emit("deleteSuspension", trip.id, index);
    },

    viewTripCalendar(item) {
      var trip_id = null;
      var suspension_id = "none";
      if (this.mode == 1 || this.mode == 3) {
        trip_id = item.id;
      } else {
        trip_id = item.trip.id;
        suspension_id = item.id;
      }
      this.$router.push({
        name: "view-calendar",
        params: { trip_id: trip_id, suspension_id: suspension_id },
      });
    },
    viewTrip(item) {
      var trip_id = null;
      if (this.mode == 1 || this.mode == 3) {
        trip_id = item.id;
      } else {
        trip_id = item.trip.id;
      }
      this.$router.push({
        name: "view-trip",
        params: { trip_id: trip_id },
      });
    },
    editTrip(trip) {
      this.$router.push({
        name: "edit-trip",
        params: { trip_id: trip.id, action: "edit" },
      });
    },
    assignDriver(item) {
      var trip_id = null;
      if (this.mode == 1 || this.mode == 3) {
        trip_id = item.id;
        this.selectedTrip = item;
      } else {
        trip_id = item.trip.id;
        this.selectedTrip = item.trip;
      }
      this.driverSearch = "";
      this.dialog = true;
      this.loadScheduleData(trip_id);
    },
    closeDriverModal() {
      this.dialog = false;
      this.loadingDrivers = false;
      this.availableDrivers = [];
      this.driverSearch = "";
      this.scheduleData = null;
      this.scheduleOccurrences = [];
      this.scheduleSummary = null;
      this.selectedOccurrence = null;
    },
    onDriverSearchInput() {
      clearTimeout(this.driverSearchTimeout);
      this.driverSearchTimeout = setTimeout(() => {
        this.loadAvailableDriversForOccurrence();
      }, 400);
    },
    onDriverSearchClear() {
      this.driverSearch = "";
      this.loadAvailableDriversForOccurrence();
    },
    loadScheduleData(tripId) {
      this.loadingSchedule = true;
      axios.get(`/trips/${tripId}/driver-assignment-schedule`)
        .then((res) => {
          this.scheduleData = res.data;
          this.scheduleOccurrences = res.data.occurrences || [];
          this.scheduleSummary = res.data.summary || null;
          if (this.scheduleOccurrences.length > 0) {
            this.selectedOccurrence = this.scheduleOccurrences[0];
            this.loadAvailableDriversForOccurrence();
          } else {
            this.selectedOccurrence = null;
            this.loadAvailableDrivers();
          }
        })
        .catch((err) => {
          console.log("Error loading schedule", err);
          this.loadAvailableDrivers();
        })
        .then(() => {
          this.loadingSchedule = false;
        });
    },
    selectOccurrence(occ) {
      this.selectedOccurrence = occ;
      this.loadAvailableDriversForOccurrence();
    },
    loadAvailableDriversForOccurrence() {
      if (!this.selectedOccurrence) {
        this.loadAvailableDrivers();
        return;
      }
      this.loadingDrivers = true;
      let params = {
        trip_id: this.selectedOccurrence.planned_trip_id,
      };
      if (this.driverSearch) {
        params.search = this.driverSearch;
      }
      axios
        .get(`/drivers/available`, { params: params })
        .then((response) => {
          this.availableDrivers = response.data.availableDrivers || [];
        })
        .catch((error) => {
          console.log(error);
          this.availableDrivers = [];
        })
        .then(() => {
          this.loadingDrivers = false;
        });
    },
    getOccurrenceBadgeColor(occ) {
      if (occ.is_paused) return "grey darken-2";
      if (occ.has_conflict) return "warning darken-1";
      if (occ.driver_id) return "success darken-1";
      return "purple lighten-4 purple--text text--darken-2";
    },
    getOccurrenceBadgeText(occ) {
      if (occ.is_paused) return "متوقفة مؤقتًا";
      if (occ.has_conflict) return "تعارض";
      if (occ.driver_id) return "تم التسكين";
      return "غير مسكن";
    },
    loadAvailableDrivers() {
      if (!this.selectedTrip) return;
      this.loadingDrivers = true;
      let params = {
        trip_id: this.selectedTrip.id,
      };
      if (this.driverSearch) {
        params.search = this.driverSearch;
      }
      axios
        .get(`/drivers/available`, { params: params })
        .then((response) => {
          this.availableDrivers = response.data.availableDrivers || [];
        })
        .catch((error) => {
          console.log(error);
          this.availableDrivers = [];
        })
        .then(() => {
          this.loadingDrivers = false;
        });
    },
    duplicateTrip(trip) {
      this.$router.push({
        name: "edit-trip",
        params: {
          trip_id: trip.id,
          action: "duplicate",
        },
      });
    },
    assignDriverToTripServer(driver) {
      if (!this.selectedOccurrence) {
        this.$swal("تنبيه", "يرجى تحديد يوم من جدول التسكين أولاً.", "warning");
        return;
      }
      if (this.scheduleData && this.scheduleData.is_parent_paused) {
        this.$swal("تنبيه", "هذه الرحلة متوقفة مؤقتًا بالكامل. أعد تفعيل الرحلة أولاً قبل التسكين.", "warning");
        return;
      }
      if (this.selectedOccurrence.is_paused) {
        this.$swal("تنبيه", "هذه الرحلة متوقفة مؤقتًا ولا يمكن تسكين سائق عليها.", "warning");
        return;
      }

      const targetPlannedTripId = this.selectedOccurrence.planned_trip_id;
      const oldDriverName = this.selectedOccurrence.driver ? this.selectedOccurrence.driver.name : null;

      const performAssignment = () => {
        this.isLoading = true;
        axios
          .post(`/planned-trips/${targetPlannedTripId}/assign-driver`, {
            planned_trip_id: targetPlannedTripId,
            driver_id: driver.id,
          })
          .then((response) => {
            this.$notify({
              title: "Success",
              text: "تم تسكين السائق بنجاح.",
              type: "success",
            });
            let idx = this.trips.findIndex((t) => t.id == this.selectedTrip.id);
            if (idx !== -1 && this.trips[idx] && response.data.driver) {
              this.trips[idx].driver = response.data.driver;
            }
            this.refreshScheduleDataOnly();
          })
          .catch((error) => {
            this.$notify({
              title: "Error",
              text: this.$t("error_assigning_driver_to_trip"),
              type: "error",
            });
            console.log(error);
            this.$swal("Error", error.response ? (error.response.data.message || error.response.data.error) : "Error", "error");
          })
          .then(() => {
            this.isLoading = false;
          });
      };

      if (oldDriverName && this.selectedOccurrence.driver_id !== driver.id) {
        this.$swal.fire({
          title: "تغيير تسكين السائق",
          text: `هذه الرحلة مسكنة حاليًا للكابتن ${oldDriverName}.\nهل تريد تغيير السائق إلى الكابتن ${driver.name}؟`,
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "نعم، تغيير السائق",
          cancelButtonText: "إلغاء",
        }).then((res) => {
          if (res.isConfirmed) {
            performAssignment();
          }
        });
      } else {
        performAssignment();
      }
    },
    refreshScheduleDataOnly() {
      if (!this.selectedTrip) return;
      axios.get(`/trips/${this.selectedTrip.id}/driver-assignment-schedule`)
        .then((res) => {
          this.scheduleData = res.data;
          this.scheduleOccurrences = res.data.occurrences || [];
          this.scheduleSummary = res.data.summary || null;
          if (this.selectedOccurrence) {
            const matched = this.scheduleOccurrences.find(o => o.planned_trip_id === this.selectedOccurrence.planned_trip_id);
            if (matched) {
              this.selectedOccurrence = matched;
            }
          }
          this.loadAvailableDriversForOccurrence();
        });
    },
    toggleOccurrencePause(occ) {
      const isPaused = occ.is_paused;
      const endpoint = isPaused ? `/planned-trips/${occ.planned_trip_id}/reactivate` : `/planned-trips/${occ.planned_trip_id}/pause`;
      const title = isPaused ? "إعادة تفعيل الرحلة" : "إيقاف الرحلة مؤقتًا";

      let text = "هل تريد إعادة تفعيل هذه الرحلة؟";
      if (!isPaused) {
        const resCount = occ.reservations_count || 0;
        if (resCount > 0) {
          text = `هذه الرحلة عليها ${resCount} حجوزات حالية.\nإيقاف الرحلة مؤقتًا لن يلغي هذه الحجوزات.\nهل تريد المتابعة؟`;
        } else {
          text = "هل تريد إيقاف هذه الرحلة مؤقتًا لهذا اليوم؟\nلن يتمكن السائق من بدء الرحلة ولن تظهر للحجوزات الجديدة حتى يتم إعادة تفعيلها.";
        }
      }

      this.$swal.fire({
        title: title,
        text: text,
        icon: isPaused ? "question" : "warning",
        showCancelButton: true,
        confirmButtonText: "نعم",
        cancelButtonText: "إلغاء",
      }).then((result) => {
        if (result.isConfirmed) {
          axios.post(endpoint)
            .then((res) => {
              this.$notify({
                title: "تمت العملية",
                text: res.data.message || "تم التحديث بنجاح.",
                type: "success"
              });
              this.refreshScheduleDataOnly();
            })
            .catch((err) => {
              const msg = err.response ? err.response.data.message : "حدث خطأ";
              this.$swal("خطأ", msg, "error");
            });
        }
      });
    },
    removeDriverFromOccurrence(occ) {
      this.$swal.fire({
        title: "إزالة السائق",
        text: "هل تريد إزالة السائق من رحلة هذا اليوم؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "نعم، إزالة",
        cancelButtonText: "إلغاء",
      }).then((result) => {
        if (result.isConfirmed) {
          axios.post(`/planned-trips/${occ.planned_trip_id}/assign-driver`, {
            planned_trip_id: occ.planned_trip_id,
            driver_id: null
          })
            .then((res) => {
              this.$notify({
                title: "تمت الإزالة",
                text: "تم إزالة السائق بنجاح.",
                type: "success"
              });
              this.refreshScheduleDataOnly();
            })
            .catch((err) => {
              const msg = err.response ? err.response.data.message : "فشل إزالة السائق";
              this.$swal("خطأ", msg, "error");
            });
        }
      });
    },
    isDriverCurrentlyAssigned(driver) {
      if (!driver || !this.selectedOccurrence) return false;
      return (this.selectedOccurrence.driver_id != null && Number(this.selectedOccurrence.driver_id) === Number(driver.id)) ||
             (this.selectedOccurrence.driver && Number(this.selectedOccurrence.driver.id) === Number(driver.id)) ||
             !!driver.is_currently_assigned;
    },
    isDriverRestricted(driver) {
      return driver && (driver.feasibility_status === 'restricted' || (driver.feasible === false && driver.conflict_reason && driver.conflict_reason.includes('مستند')));
    },
    isDriverConflict(driver) {
      if (this.isDriverCurrentlyAssigned(driver)) return false;
      return driver && (driver.trip_intersect || (driver.feasible === false && !this.isDriverRestricted(driver)));
    },
    getDriverNoticeMessage(driver) {
      if (!driver) return null;
      if (this.isDriverCurrentlyAssigned(driver)) return null;
      if (driver.feasible === false && driver.conflict_reason) return driver.conflict_reason;
      if (driver.trip_intersect) {
        return `تعارض مع رحلة (#${driver.trip_intersect.id}) على مسار (${driver.trip_intersect.route ? driver.trip_intersect.route.name : ''})`;
      }
      return null;
    },
    assignDriverToTrip(driver) {
      if (this.isDriverCurrentlyAssigned(driver)) {
        this.$notify({
          title: "معلومة",
          text: "هذا السائق مسكن بالفعل لهذه الرحلة.",
          type: "info",
        });
        return;
      }
      if (this.isDriverRestricted(driver)) {
        this.$swal("تنبيه", driver.conflict_reason || "غير متاح: يوجد مستند مرفوض يمنع تعيين السائق.", "error");
        return;
      }
      if (this.isDriverConflict(driver)) {
        const noticeMsg = this.getDriverNoticeMessage(driver);
        this.$swal({
          title: "تنبيه تعارض في جدول السائق",
          html: noticeMsg + "<br/><br/><strong>هل أنت متأكد من رغبتك في محاولة تعيين هذا السائق؟</strong>",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "نعم، حاول التعيين",
          cancelButtonText: "إلغاء",
        }).then((result) => {
          if (result.isConfirmed) {
            this.assignDriverToTripServer(driver);
          }
        });
      } else {
        this.assignDriverToTripServer(driver);
      }
    },
    onAssignedFinished() {
      this.dialog = false;
      this.driverSearch = "";
    }
  },
};
</script>
<style lang="scss">
.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover{
  cursor: pointer;
  background: rgba($primary-shade--light, 0.15) !important;
}

.occurrence-card {
  border: 2px solid #e2e8f0;
  transition: all 0.2s ease-in-out;
  background-color: #ffffff;
}
.occurrence-card:hover {
  border-color: #94a3b8;
}
.occurrence-card-selected {
  border-color: #6200ee !important;
  box-shadow: 0 0 0 2px rgba(98, 0, 238, 0.25) !important;
}
.occurrence-card-assigned {
  border-top: 4px solid #4caf50 !important;
}
.occurrence-card-unassigned {
  border-top: 4px solid #7c4dff !important;
  background-color: #f3e5f5 !important;
}
.occurrence-card-conflict {
  border-top: 4px solid #ff9800 !important;
  background-color: #fffde7 !important;
}
.occurrence-card-paused {
  border-top: 4px solid #757575 !important;
  background-color: #f5f5f5 !important;
}

.driver-card {
  border: 1px solid #e2e8f0;
  transition: all 0.2s ease-in-out;
  background-color: #ffffff;
  &:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.06);
  }
}
.driver-card-available {
  border-inline-start: 4px solid #4caf50 !important;
}
.driver-card-conflict {
  border-inline-start: 4px solid #ff9800 !important;
  background-color: #fffde7 !important;
}
.driver-card-restricted {
  border-inline-start: 4px solid #f44336 !important;
  background-color: #ffebee !important;
}
</style>
